export default "__VITE_ASSET__shNZiRnV__"